<template>
<div id="pedimentos_referencias" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Agregar Planta/Referencia" class="elevation-1 px-5 py-3" >
                    
                    <v-tabs grow style="margin-bottom: 30px;" >
                        <v-tabs-slider color="primary" ></v-tabs-slider>
                        <v-tab key="pedimentos" >Layout para asignar planta/referencia a pedimentos</v-tab>            
                        <v-tab key="referencias" >Catálogo de Plantas/Referencias</v-tab>
                        
                        <v-tab-item key="pedimentos" >
                        <div class="contenedor-tab-reportes" >
                            <v-card-text>
                            <v-card-title>
                                <span class="headline" ></span>
                            </v-card-title>
                            
                            </v-card-text>
                            
                            <v-card-text>
                                <v-row>
                                    <v-col sm="4" md="4" lg="4" >
                                        1.- Descargar Layout e ingresar información:
                                    </v-col>
                                    <v-col sm="1" md="1" lg="1" >
                                        <exportar-excel :data="representantes.camposLayout" :exportFields="representantes.encabezadoLayout" name="Layout Referencia.xlsx" >
                                        <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                            <v-icon dark>receipt</v-icon>
                                        </v-btn>
                                    </exportar-excel>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col sm="4" md="4" lg="4" >
                                        2.- Cargar el layout:
                                    </v-col>
                                    <v-col sm="1" md="1" lg="1" >
                                        <upload-excel-component :on-success="handleSuccess" :before-upload="beforeUpload" />
                                    </v-col>
                                </v-row>
                                    
                            
                            </v-card-text>
                        </div>
                        </v-tab-item>            
                        <v-tab-item key="referencias" >
                        <div class="contenedor-tab-reportes" >
                            <v-card-text>
                            <v-card-title>
                                <span class="headline" ></span>
                                <span class="subheading" >                          
                                </span>
                            </v-card-title>                  
                                <v-container grid-list-md text-xs-center>
                                <v-client-table :data="referencias" :columns="columnsReferencias" :options="optionsReferencias" class="elevation-2 pa-2" >
                                    <template slot="noResults" >
                                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                    </template>                              
                                </v-client-table>
                                </v-container>
                                <v-card-text>
                                    
                                </v-card-text>
                            
                            </v-card-text>                                
                        </div>
                        </v-tab-item>

                    </v-tabs>
                    
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
    components: {        
    },

    data: () => ({
        referenciasArray: [],
        referencias: [],
        menu1: false,
        name: "datagrid",
        importData: [],
        columns: [
            "nombre",
            "apellido_paterno",
            "apellido_materno",
            "rfc",
            "aplicacion_estado",
            "estado",
            "metadato",
            "actions"
        ],
        show_loading: true,
        options: {
            filterable: [
                "nombre",
                "apellido_paterno",
                "apellido_materno",
                "rfc",
                "aplicacion_estado",
                "estado",
                "metadato"
            ],
            sortable: [
                "nombre",
                "apellido_paterno",
                "apellido_materno",
                "rfc",
                "aplicacion_estado",
                "estado",
                "metadato"
            ],

            headings: {
                nombre: "Nombre",
                apellido_paterno: "Apellido Paterno",
                apellido_materno: "Apellido Materno",
                rfc: "RFC o TAX ID",
                aplicacion_estado: "Estado de Aplicación",
                estado: "Estado",
                metadato: "Metadato",
                actions: "Operaciones"
            },
              
        },
        columnsReferencias: [
            "referencia",            
        ],        
        optionsReferencias: {
            filterable: ["referencia"],
            sortable: ["referencia"],
            headings: {
                referencia: "Referencia",                
            },
            headings: {
                referencia: "Planta/Referencia",                
            },
              
        },
        URL: "",
        show_loading: true,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Reportes",
                disabled: true,
                to: ""
            },
            {
                text: "Agregar Planta/Referencia a Pedimentos",
                disabled: true,
                to: ""
            }
        ],
        loading: false,
        title: "",
        modal: false,
        update: false,
        pagination: {
            sortBy: "nombre"
        },
        search: "",
        model: {
            id_representante_legal: 0,
            nombre: "",
            apellido_paterno: "",
            apellido_materno: "",
            rfc: "",
            escritura_publica: "",
            volumen: "",
            ciudad: "",
            fecha: "",
            numero_notario: "",
            nombre_notario: "",            
            estado: "",
            cliente: 0,
            metadato: "N/A"
        },
        rules: {
            required: v => !!v || "Este campo es requerido",
            rfclen: v =>
                (v && v.length >= 9) || "RFC debe tener al menos 9 caractéres"
        },
        representantes: {
            selected: [],
            camposexcel: {
                Pedimento: "pedimento",
                "Año": "anio",
                "Referencia": "referencia",                
            },
            items: [0],
            //En el encabezado deben ser iguales los pares, respetando el nombre del campo definido en el modelo de la API
            encabezadoLayout: {
                pedimento: "pedimento",
                anio: "anio",
                referencia: "referencia",                
            },
            //van vacíos para solo descargar layout con encabezados
            camposLayout: [{
                pedimento: "[No de Pedimento. Ej. 370-3668-9000123]",
                anio: "[Año del pedimento]",
                referencia: "[Referencia del pedimento. Vacío o una palabra válida del catálogo de referencias]",                
            }]
        },
        camposObligatorios: [
            "pedimento",
            "anio",            
        ],
        estados: [],
        paises: [],
    }),
    computed: {
        datafiltered() {
            if (this.$refs.vuetable != null) {
                return this.$refs.vuetable.allFilteredData;
            } else {
                return this.representantes.items;
            }

        },
    },
    methods: {
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        openModal: function (type) {
            if (type === 1) {
                this.limpiarModel();
                this.title = "Nuevo Representante Legal";
                this.update = false;
            } else {
                this.title = "Actualizar Representante Legal";
                this.update = true;
            }
            this.modal = true;
        },

        limpiarModel: function () {
            for (var k in this.model) {
                this.model[k] = "";
            }
            this.model.cliente = this.$local_storage.get("id_cliente");
        },

        guardar() {
            const datos = {
                id_representante_legal: this.model.id_representante_legal,
                nombre: this.model.nombre,
                apellido_paterno: this.model.apellido_paterno,
                apellido_materno: this.model.apellido_materno,
                rfc: this.model.rfc,
                escritura_publica: this.model.escritura_publica,
                volumen: this.model.volumen,
                ciudad: this.model.ciudad,
                fecha: this.model.fecha,
                numero_notario: this.model.numero_notario,
                nombre_notario: this.model.nombre_notario,
                aplicacion_estado: this.model.aplicacion_estado.id_estado,
                estado: this.model.estado.id_estado,
                cliente: this.$local_storage.get("id_cliente"),
                metadato: this.model.metadato
            };

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var metodo = "post";
                var urlCliente = this.URL;
                if (this.update == true) {
                    metodo = "put";
                    urlCliente += this.model.id_representante_legal + "/";
                }
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                        this.cargar();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    })
                    .catch(error => {
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos"
                            //showConfirmButton: false,
                        });
                        console.log(error);
                        this.cargar();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    });
            }
        },
        cargarReferencias: function(){
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                cliente: this.$local_storage.get("id_cliente")
            };
            axios.post(this.$hostname + "catalogos/referencias/get_referencias/", datos)
            .then(res => {
                if (typeof res.data !== "undefined") {
                    this.referencias = res.data;
                    var self = this;
                    this.referencias.forEach(e => {
                        self.referenciasArray.push(e.referencia);
                    });
                    this.$root.$dialogLoader.hide();
                }
            })
            .catch(err => {                   
                console.log(err);
                this.$root.$dialogLoader.hide();
            }).then(()=>{
                this.$root.$dialogLoader.hide();
            });
        },
        cargar: function () {
            var datos = {
                cliente: this.$local_storage.get("id_cliente")
            };
            axios
                .post(this.URL + "get_representantes/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.representantes.items = res.data;
                        this.$root.$dialogLoader.hide();
                    }
                })
                .catch(err => {
                   
                    console.log(err);
                    this.$root.$dialogLoader.hide();
                });
        },

            
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        validarPatronPedimento(pedimento){
            const patternPedimento = /^[0-9]{3}-{1}[0-9]{4}-{1}[0-9]{7}$/;
            return patternPedimento.test(pedimento);
        },
        validaReferencia(referencia){
            return this.referenciasArray.includes(referencia);
        },
        validaEntero(numero){
            const pattern = /^[\d]*$/;
            return pattern.test(numero);
        },
       
        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }
            this.camposObligatorios.forEach(function (campo) {
                if (keys.indexOf(campo) == -1)
                    errores += '<br/>' + "- El campo '" + campo + "' es obligatorio.";
            });

            return errores == '' ? true : errores;
        },
                
        validaCargaLayout: async function (results) {
            var thisObject = this;
            //return new Promise(function(resolve, reject){
            var errores = 0;
            var erroresText = '';
            var errorTmp = '';
            try {
                if (results.length == 0) {
                    errores++;
                    erroresText += "No hay datos en el layout. Verifique que exista información a partir del 3er renglón.";
                } else if (results.length > 500){
                    errores++;
                    erroresText += "El máximo de filas a procesar es 500, favor de verificar.";
                } else {
                    for (var k in results) {                        
                        results[k]["rfc"] = this.$local_storage.get("rfc");

                        var obligatorios = this.verificaObligatorios(results[k]);
                        if (obligatorios !== true) {
                            errores++;
                            if (erroresText.indexOf(obligatorios) == -1)
                                erroresText += obligatorios;
                        } else {
                            
                            if(!this.validarPatronPedimento(results[k]['pedimento'])){
                                errores++;
                                errorTmp = '<br/>' + "- El número '" + results[k]['pedimento'] + "' no es un pedimento válido. Ej. 240-1234-9000123";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if(!this.validaEntero(results[k]['anio'])){
                                errores++;
                                errorTmp = '<br/>' + "- El número '" + results[k]['anio'] + "' no es un número entero válido.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if(results[k]['referencia']!= undefined){
                                results[k]['referencia'] = results[k]['referencia'].toString().trim();
                                if (results[k]['referencia']!="")
                                    if(!this.validaReferencia(results[k]['referencia'])){
                                        errores++;
                                        errorTmp = '<br/>' + "- La referencia '" + results[k]['referencia'] + "' no es válida, favor de revisar las referencias.";
                                        if (erroresText.indexOf(errorTmp) == -1)
                                            erroresText += errorTmp;
                                    }
                            }

                        }
                        //console.log("Key is " + k + ", value is" + results[k]);
                    }

                }

                return ({
                    "errores": errores,
                    "erroresText": erroresText
                });

            } catch (error) {
                console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
            }
            //}); //promise

        },
        handleSuccess: async function ({
            results,
            header
        }) {
            var errores = 0;
            var erroresText = '';
            this.importData = [];
            try {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText,
                    });
                    this.$root.$dialogLoader.hide();
                } else {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    axios.post(this.$hostname + "vucem/save_referencia/", results)                    
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "Los datos se guardaron correctamente",
                                footer: ""
                            });
                        })
                        .catch(err => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al guardar los datos. Favor de comunicarse con soporte.",
                                footer: ""
                            });
                        }).then(() => {
                            this.cargar();
                            this.$root.$dialogLoader.hide();
                        });
                    
                }

            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
                this.$root.$dialogLoader.hide();
            }
        }
    }, //methods

    created: function () {
        this.URL = this.$hostname + "catalogos/representantes/";
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.cargar();        
       this.cargarReferencias()
    }
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
  font-size: x-small !important;
}
.elevation-1 .v-expansion-panel >>> .v-label.theme--light {
        color: black !important;
    }    

</style>
